export enum LinkSourceTypeEnum {
  Popup = 'Popup',
  Blog = 'Blog',
  Input = 'Input',
}
